export function displayValue(
  value: string | number | null | undefined
): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return String(value);
}
